import { UPDATE_COUPON_ON_SUCCESS } from 'root/src/client/logic/coupon/actionIds'

export default payload => ({
	type: UPDATE_COUPON_ON_SUCCESS,
	payload,
})
